export default __webpack_public_path__ + "static/textlist_home_1_img_0-f820794bf7fb7868efd611aa1f84e70c.png";